import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  CommonEventProps,
  customEvent,
  HStack,
  NextLink,
  VStack,
} from "goi_common";
import { ReactNode, useMemo } from "react";

export default function BannerCTA({
  variant = "DARK",
  subtitle,
  title,
  event,
  onClick,
  align = "space-between",
  href,
}: {
  variant: "DARK" | "GREEN" | "DEEP_DARK";
  align?: string;
  subtitle: string | ReactNode;
  title: string;
  event: CommonEventProps;
  onClick?: () => void;
  href: string;
}) {
  const theme = useMemo(() => {
    if (variant === "GREEN") {
      return {
        backgroundColor: "#036600bb",
        subtitleColor: "white",
        titleColor: "white",
        arrowColor: colors.green500,
      };
    }

    if (variant === "DEEP_DARK") {
      return {
        backgroundColor: colors.gray900,
        subtitleColor: "gray300",
        titleColor: "white",
        arrowColor: colors.orange950,
      };
    }

    return {
      backgroundColor: "#000000bb",
      subtitleColor: "gray300",
      titleColor: "white",
      arrowColor: colors.orange950,
    };
  }, [variant]);
  return (
    <NextLink href={href}>
      <HStack
        gap={12}
        padding="12px 16px"
        background={theme.backgroundColor}
        justifyContent={align}
        alignItems="center"
        css={{ cursor: "pointer" }}
        onClick={() => {
          customEvent({
            newGtm: event,
          });
          onClick && onClick();
        }}
      >
        <VStack>
          <Box className={`caption_12_b ${theme.subtitleColor}`}>{subtitle}</Box>

          <div className={`subtitle_14_b ${theme.titleColor}`}>{title}</div>
        </VStack>
        <VStack
          background="white"
          width="32px"
          height="32px"
          borderRadius="32px"
          alignItems="center"
          justifyContent="center"
          boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
        >
          <ColorIcon name="arrow_right_small" size={18} color={theme.arrowColor} />
        </VStack>
      </HStack>
    </NextLink>
  );
}
